import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './ConfirmModal.css';

const UnsavedChangesModal = ({ isOpen, onClose, onSaveAndClose, onCloseWithoutSave }) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const modal = (
    <div className="confirm-modal-overlay" onClick={onClose}>
      <div
        className="confirm-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirm-modal-header">
          <div className="confirm-modal-title-wrap">
            <div className="confirm-modal-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
                <path d="M12 9v4" />
                <path d="M12 17h.01" />
              </svg>
            </div>
            <h3>Несохранённые изменения</h3>
          </div>
          <button type="button" className="confirm-modal-close" onClick={onClose} aria-label="Закрыть">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <div className="confirm-modal-body">
          <p>У вас есть несохранённые изменения. Что вы хотите сделать?</p>
        </div>
        <div className="confirm-modal-footer confirm-modal-footer--split">
          <button type="button" className="btn-confirm-cancel" onClick={onClose}>
            Отмена
          </button>
          <div className="confirm-modal-footer-actions">
            <button type="button" className="btn-confirm-cancel" onClick={onCloseWithoutSave}>
              Закрыть
            </button>
            <button type="button" className="btn-confirm-ok" onClick={onSaveAndClose}>
              Сохранить и закрыть
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default UnsavedChangesModal;
